import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col md:mx-0 md:w-1/3 xl:w-1/4 px-4" }
const _hoisted_2 = { class: "text-3xl font-bold text-gray-900 text-center mb-6 t" }
const _hoisted_3 = { class: "w-full w-lg flex flex-col rounded border p-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "border-t my-3" }, null, -1)
const _hoisted_5 = { class: "text-sm font-medium text-center text-gray-600" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fr_alert = _resolveComponent("fr-alert")!
  const _component_TextField = _resolveComponent("TextField")!
  const _component_fr_button = _resolveComponent("fr-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_vee_form = _resolveComponent("vee-form")!
  const _component_centered_layout = _resolveComponent("centered-layout")!

  return (_openBlock(), _createBlock(_component_centered_layout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t('signup.title')), 1),
        (_ctx.message.message)
          ? (_openBlock(), _createBlock(_component_fr_alert, {
              key: 0,
              "show-dismiss": "",
              type: _ctx.message.type,
              onOnClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.message.message = null))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.message.message), 1)
              ]),
              _: 1
            }, 8, ["type"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_vee_form, {
            "initial-values": _ctx.initialValues,
            onSubmit: _ctx.register
          }, {
            default: _withCtx(({ meta }) => [
              _createVNode(_component_TextField, {
                name: "name",
                rules: "required",
                type: "text",
                title: _ctx.$t('auth.name'),
                placeholder: _ctx.$t('signup.name_placeholder'),
                class: "mb-3"
              }, null, 8, ["title", "placeholder"]),
              _createVNode(_component_TextField, {
                name: "email",
                rules: "required|email",
                type: "email",
                title: _ctx.$t('auth.email'),
                placeholder: _ctx.$t('signup.email_placeholder'),
                class: "mb-3"
              }, null, 8, ["title", "placeholder"]),
              _createVNode(_component_TextField, {
                name: "phoneNumber",
                rules: "required",
                type: "text",
                title: _ctx.$t('auth.phone_number'),
                placeholder: _ctx.$t('signup.phonumber_placeholder'),
                class: "mb-3"
              }, null, 8, ["title", "placeholder"]),
              _createVNode(_component_TextField, {
                name: "password",
                rules: "required",
                type: "password",
                title: _ctx.$t('auth.password'),
                placeholder: _ctx.$t('signup.password_placeholder'),
                class: "mb-3"
              }, null, 8, ["title", "placeholder"]),
              _createVNode(_component_TextField, {
                name: "confirmPassword",
                rules: "required",
                type: "password",
                title: _ctx.$t('auth.confirm_password'),
                placeholder: _ctx.$t('signup.confirm_password_placeholder'),
                class: "mb-3"
              }, null, 8, ["title", "placeholder"]),
              _createVNode(_component_fr_button, {
                disabled: _ctx.loading || !meta.valid,
                type: "submit",
                block: "",
                loading: _ctx.loading,
                color: "primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('signup.button_text')), 1)
                ]),
                _: 2
              }, 1032, ["disabled", "loading"]),
              _hoisted_4,
              _createElementVNode("p", _hoisted_5, [
                _createTextVNode(_toDisplayString(_ctx.$t('signup.already_registered_text')) + " ", 1),
                _createVNode(_component_router_link, {
                  to: "sign-in",
                  class: "text-blue-600 opacity-75 hover:opacity-100"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('signup.click_here_text')), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["initial-values", "onSubmit"])
        ])
      ])
    ]),
    _: 1
  }))
}